<template>
    <AdminLayout>
        <template #header>
            <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
        </template>
        <template #default>
            <div class="mt-10 space-y-6">
                <!-- Header -->
                <div class="flex items-center justify-between">
                    <div>
                        <h1 class="text-2xl font-bold text-gray-900">Tambah Agenda Kegiatan</h1>
                        <p class="mt-1 text-sm text-gray-600">
                            Buat agenda kegiatan baru
                        </p>
                    </div>
                    <Link :href="route('agenda.index')"
                        class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-gray-700 uppercase transition duration-150 ease-in-out bg-gray-300 border border-transparent rounded-md hover:bg-gray-400">
                    <i class="mr-2 fas fa-arrow-left"></i>
                    Kembali
                    </Link>
                </div>

                <!-- Form -->
                <div class="bg-white rounded-lg shadow-lg">
                    <form @submit.prevent="submit" class="p-6 space-y-6">
                        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                            <!-- Judul -->
                            <div class="md:col-span-2">
                                <label for="judul" class="block mb-2 text-sm font-medium text-gray-700">
                                    Judul Agenda <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="judul" v-model="form.judul" placeholder="Masukkan judul agenda"
                                    :class="[
                                        'block w-full rounded-md shadow-sm sm:text-sm',
                                        errors.judul
                                            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                            : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                    ]">
                                <p v-if="errors.judul" class="mt-1 text-sm text-red-600">
                                    {{ errors.judul }}
                                </p>
                            </div>



                            <!-- Tanggal -->
                            <div>
                                <label for="tanggal" class="block mb-2 text-sm font-medium text-gray-700">
                                    Tanggal <span class="text-red-500">*</span>
                                </label>
                                <input type="date" id="tanggal" v-model="form.tanggal" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.tanggal
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                ]">
                                <p v-if="errors.tanggal" class="mt-1 text-sm text-red-600">
                                    {{ errors.tanggal }}
                                </p>
                            </div>

                            <!-- Waktu Mulai -->
                            <div>
                                <label for="waktu_mulai" class="block mb-2 text-sm font-medium text-gray-700">
                                    Waktu Mulai <span class="text-red-500">*</span>
                                </label>
                                <input type="time" id="waktu_mulai" v-model="form.waktu_mulai" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.waktu_mulai
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                ]">
                                <p v-if="errors.waktu_mulai" class="mt-1 text-sm text-red-600">
                                    {{ errors.waktu_mulai }}
                                </p>
                            </div>

                            <!-- Waktu Selesai -->
                            <div>
                                <label for="waktu_selesai" class="block mb-2 text-sm font-medium text-gray-700">
                                    Waktu Selesai <span class="text-red-500">*</span>
                                </label>
                                <input type="time" id="waktu_selesai" v-model="form.waktu_selesai" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.waktu_selesai
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                ]">
                                <p v-if="errors.waktu_selesai" class="mt-1 text-sm text-red-600">
                                    {{ errors.waktu_selesai }}
                                </p>
                            </div>

                            <!-- Tempat -->
                            <div>
                                <label for="tempat" class="block mb-2 text-sm font-medium text-gray-700">
                                    Tempat <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="tempat" v-model="form.tempat"
                                    placeholder="Masukkan tempat kegiatan" :class="[
                                        'block w-full rounded-md shadow-sm sm:text-sm',
                                        errors.tempat
                                            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                            : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                    ]">
                                <p v-if="errors.tempat" class="mt-1 text-sm text-red-600">
                                    {{ errors.tempat }}
                                </p>
                            </div>

                            <!-- Penyelenggara -->
                            <div>
                                <label for="penyelenggara" class="block mb-2 text-sm font-medium text-gray-700">
                                    Penyelenggara <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="penyelenggara" v-model="form.penyelenggara"
                                    placeholder="Masukkan penyelenggara" :class="[
                                        'block w-full rounded-md shadow-sm sm:text-sm',
                                        errors.penyelenggara
                                            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                            : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                    ]">
                                <p v-if="errors.penyelenggara" class="mt-1 text-sm text-red-600">
                                    {{ errors.penyelenggara }}
                                </p>
                            </div>
                        </div>

                        <!-- Deskripsi -->
                        <div>
                            <label for="deskripsi" class="block mb-2 text-sm font-medium text-gray-700">
                                Deskripsi <span class="text-red-500">*</span>
                            </label>
                            <textarea id="deskripsi" v-model="form.deskripsi" rows="4"
                                placeholder="Masukkan deskripsi agenda..." :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.deskripsi
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-green-500 focus:ring-green-500'
                                ]"></textarea>
                            <p v-if="errors.deskripsi" class="mt-1 text-sm text-red-600">
                                {{ errors.deskripsi }}
                            </p>
                        </div>

                        <!-- Form Actions -->
                        <div class="flex items-center justify-end pt-6 space-x-4 border-t border-gray-200">
                            <Link :href="route('agenda.index')"
                                class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-gray-700 uppercase transition duration-150 ease-in-out bg-gray-300 border border-transparent rounded-md hover:bg-gray-400">
                            Batal
                            </Link>
                            <button type="submit" :disabled="form.processing" :class="[
                                'inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest transition ease-in-out duration-150',
                                form.processing
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-green-600 hover:bg-green-700'
                            ]">
                                <i v-if="form.processing" class="mr-2 fas fa-spinner fa-spin"></i>
                                <i v-else class="mr-2 fas fa-save"></i>
                                {{ form.processing ? 'Menyimpan...' : 'Simpan Agenda' }}
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Help Text -->
                <div class="p-4 border border-green-200 rounded-md bg-green-50">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <i class="text-green-400 fas fa-info-circle"></i>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-green-800">
                                Petunjuk Pengisian
                            </h3>
                            <div class="mt-2 text-sm text-green-700">
                                <ul class="space-y-1 list-disc list-inside">
                                    <li>Semua field yang bertanda (*) wajib diisi</li>
                                    <li>Pilih jenis agenda yang sesuai dengan kegiatan</li>
                                    <li>Pastikan waktu mulai lebih awal dari waktu selesai</li>
                                    <li>Deskripsi sebaiknya menjelaskan tujuan dan detail kegiatan</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer></template>
    </AdminLayout>
</template>

<script setup>
import { reactive } from 'vue'
import { Link, useForm } from '@inertiajs/vue3'
import AdminLayout from '@/Layouts/Container.vue'
import Header from "@/Components/Header.vue";

const props = defineProps({
    errors: Object,

})

const form = useForm({
    judul: '',
    tanggal: '',
    waktu_mulai: '',
    waktu_selesai: '',
    tempat: '',
    penyelenggara: '',
    deskripsi: ''
})

const submit = () => {
    form.post(route('agenda.store'), {
        onSuccess: () => {
            // Success handled by redirect
        }
    })
}
</script>